import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getPriceDisplay = (product) => {
    if (product.variantPrices) {
      const prices = Object.values(product.variantPrices).map((p) => Number(p));
      const minPrice = Math.min(...prices);
      const maxPrice = Math.max(...prices);
      if (minPrice !== maxPrice) {
        return `$${minPrice.toFixed(2)} / $${maxPrice.toFixed(2)}`;
      }
      return `$${minPrice.toFixed(2)}`;
    }
    return `$${Number(product.price).toFixed(2)}`;
  };

  return (
    <div className="shop main">
      <div className="shop-grid">
        {productData.map((product) => (
          <div className="product-card" key={product.id}>
            <Link
              to={`/shopDetails/${product.id}`}
              onClick={toTop}
              className="product-image-link"
            >
              <img src={product.image} alt={product.name} />
            </Link>
            <div className="product-info">
              <Link
                to={`/shopDetails/${product.id}`}
                onClick={toTop}
                className="product-name"
              >
                {product.name}
              </Link>
              <div className="product-price">{getPriceDisplay(product)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Shop;
